import { useFunctions } from '../hooks/useFirebase';

export const name = 'findExactCompanyName';
export const description = 'Searches for the exact and official company names registered in Hungary. Use this tool whenever another tool requires a company name parameter to lookup and verify the exact name first.';
export const parameters = {
  search: 'The name or search term of the company to look up.'
};
export const outputTextForUI = 'Cég keresése';
export const useOnMobile = true;

export async function findExactCompanyName(args: { search: string }) {
  if (!args || !args.search) {
    throw new Error('A keresési kulcsszó megadása kötelező.');
  }

  const searchFunc = useFunctions('searchCompanyName');
  const res = await searchFunc({ search: args.search });
  const data = res.data as { success: boolean; results: string[] };

  if (data.success) {
    return {
      success: true,
      results: data.results
    };
  } else {
    throw new Error('Hiba történt a cég keresése közben.');
  }
}
